/* ------------------------------------------------------------------
   LimitReachedModal.js — generic "you hit a plan limit → upgrade" popup.
   Mirrors the Accounts limit modal; reusable for any quota wall.
------------------------------------------------------------------ */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function LimitReachedModal({ show, onHide, title, message, cta = 'See upgrade options' }) {
  const navigate = useNavigate();
  if (!show) return null;
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || 'Limit reached'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="mb-4">{message}</p>
        <Button variant="primary" className="w-100" onClick={() => { onHide(); navigate('/dashboard/plans'); }}>
          {cta}
        </Button>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Maybe later</Button>
      </Modal.Footer>
    </Modal>
  );
}
